module.exports = __webpack_public_path__ + "static/img/logot.fcf024fc.png";